import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getChannels = (params) => httpClient.get(`${ENDPOINT_API.CHANNELS}`, { params });
const getChannel = (id) => httpClient.get(`${ENDPOINT_API.CHANNELS}/${id}`);
const postChannel = (params) => httpClient.post(`${ENDPOINT_API.CHANNELS}`, params);
const putChannel = (id, params) => httpClient.put(`${ENDPOINT_API.CHANNELS}/${id}`, params);
const deleteChannel = (id) => httpClient.delete(`${ENDPOINT_API.CHANNELS}/${id}`);

export {
	getChannels,
	getChannel,
	postChannel,
	putChannel,
	deleteChannel,
};
